import { UniqueIdentifier, useDndContext, useDroppable } from '@dnd-kit/core';
import { faGripVertical } from '@fortawesome/pro-solid-svg-icons/faGripVertical';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { Box } from '@osmosis/react-ui/components/Box';
import { Flex } from '@osmosis/react-ui/components/Box';
import { ReactElement } from 'react';
import { P } from '@osmosis/react-ui/components/Text';

/**
 * SentenceDroppableContainer.
 */
export const SentenceDroppableContainer = ({
  children,
  id,
  allQuestions,
}: {
  children?: ReactElement;
  id: UniqueIdentifier;
  allQuestions: { value: string; id: UniqueIdentifier }[];
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id,
  });

  const { active } = useDndContext();

  const color = useColors();

  const question = allQuestions.find((i) => i.id === active?.id);

  const renderPlaceholder = isOver && question && !children;

  return (
    <Box
      sx={
        !children
          ? {
              border: '1px solid',
              borderRadius: '5px',
              borderColor: 'gray20',
              minHeight: children ? 'auto' : '33px',
              width: children ? 'auto' : '200px',
              margin: 2,
              padding: '5px 10px',
              background: renderPlaceholder ? color.gray10 : 'initial',
              display: 'inline-block',
              position: 'relative',
              top: '15px',
            }
          : { width: 'max-content', margin: 1, display: 'inline-block' }
      }
      ref={children ? null : setNodeRef}
    >
      {renderPlaceholder ? (
        <Flex
          data-testid="sentence-droppable-container"
          alignItems="center"
          sx={{
            maxWidth: '200px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          <Icon color={color.gray60} icon={faGripVertical} />
          <P ml={2} dangerouslySetInnerHTML={{ __html: `${question.value}` }} />
        </Flex>
      ) : (
        children
      )}
    </Box>
  );
};
